/**
 * StreamingText — renders text with a blinking cursor during streaming
 */
import { useEffect, useRef } from 'react'

interface Props {
  text: string
  isStreaming: boolean
  className?: string
}

export function StreamingText({ text, isStreaming, className = '' }: Props) {
  const endRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (isStreaming && endRef.current) {
      endRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }, [text, isStreaming])

  return (
    <span className={className}>
      {text}
      {isStreaming && (
        <span
          ref={endRef}
          className="inline-block w-1.5 h-4 ml-0.5 themed-bg-primary animate-pulse align-text-bottom"
        />
      )}
    </span>
  )
}
